import React from "react";
import { isMobile } from "react-device-detect";
import { useQuery } from "@apollo/client";
import DesktopHeader from "../../Header/DesktopHeader";
import MobileHeader from "../../Header/MobileHeader";
import DeskFooter from "../DeskFooter";
import MobileFooter from "../MobileFooter";
import DesktopAboutKm from "./DesktopAboutKm";
import MobileAboutKm from "./MobileAboutKm";
import SeoManager from "../../seoManager";

import { About_KM } from "../../../gqlOperations/queries";

export default function AboutKM() {
  // document.title = "About KheloMore | India’s Sports & Fitness Community";
  const { loading, error, data } = useQuery(About_KM);
  const htmlData = data?.aboutKms?.data.map(
    (details) => details?.attributes?.Value,
  );

  return (
    <>
      <SeoManager
        pageTitle="About KheloMore | India’s Sports & Fitness Community"
        description="Learn about KheloMore’s mission to make sports a daily habit through venue booking, coaching, events, and active communities across India."
      />
      {isMobile ? (
        <div>
          <MobileHeader />
          <div>
            {/* <div dangerouslySetInnerHTML={{ __html: htmlData }} /> */}
            <MobileAboutKm />
          </div>
          <MobileFooter />
        </div>
      ) : (
        <div>
          <DesktopHeader />
          <div>
            {/* <div dangerouslySetInnerHTML={{ __html: htmlData }} /> */}
            <DesktopAboutKm />
          </div>
          <DeskFooter />
        </div>
      )}
    </>
  );
}
